import React, { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface StatusNotificationProps {
  message: string;
  type: 'success' | 'warning' | 'error';
  onClose: () => void;
}

const StatusNotification: React.FC<StatusNotificationProps> = ({ message, type, onClose }) => {
  const { colors } = useTheme();

  // Auto close after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        );
      case 'warning':
        return (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        );
      case 'error':
        return (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        );
    }
  };

  const getNotificationStyles = () => {
    switch (type) {
      case 'success':
        return {
          backgroundColor: colors.success,
          color: '#ffffff',
          borderColor: colors.success,
        };
      case 'warning':
        return {
          backgroundColor: colors.warning,
          color: '#ffffff',
          borderColor: colors.warning,
        };
      case 'error':
        return {
          backgroundColor: colors.danger,
          color: '#ffffff',
          borderColor: colors.danger,
        };
    }
  };

  const notificationStyles = getNotificationStyles();

  return (
    <div 
      className="fixed bottom-5 right-5 z-50 flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg border animate-slide-up max-w-md"
      style={notificationStyles}
    >
      <div className="flex-shrink-0">
        {getIcon()}
      </div>
      <span className="text-sm font-medium flex-1">{message}</span>
      <button
        onClick={onClose}
        title="关闭"
        aria-label="关闭通知"
        className="ml-2 p-1 hover:bg-black/10 rounded-full transition-colors duration-200 flex-shrink-0"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default StatusNotification; 